<template>
  <div class="w-full max-w-7xl mx-auto px-[4vw] pb-12">
    <Head>
      <Title>{{ $t('giftcards.city.meta.title', { city: fat.city?.name }) }}</Title>
      <Meta name="description" :content="$t('giftcards.city.meta.description', { city: fat.city?.name })" />
    </Head>
    <AtomPageHeader class="mt-2 lg:mt-8"
      :heading="$t('giftcards.city.heading', { city: fat.city?.name })"
      :leading="$t('giftcards.city.leading', { city: fat.city?.name })"
    />
    <GiftcardsList class="mt-6" />
  </div>
</template>

<script setup>
const route = useRoute()
const fat = useFatStore()

// Show 404 if city slug is undefined 
if (!useCityBySlug(route.params?.city)) {
  throw createError({
    statusCode: 404,
    message: 'not found',
    fatal: true
  })
}
</script>
